const source = [
    {
        id: 1,
        imgsrc: 'http://t3.gstatic.com/images?q=tbn:ANd9GcQzBPeJBL1nrbE44py9eA0PFWzRQjQlW4NwjIBKuOMjVi4ou8UR',
        title: 'Stranger Things',
        channel: 'Netflix Original Series',
        link: 'https://www.netflix.com/title/80057281'
    },
    {
        id: 2,
        imgsrc: 'https://www.mediaguru.com/wp-content/uploads/2018/06/13-Reasons-why_-Netflix.jpg',
        title: '13 Reasons Why',
        channel: 'Netflix Original Series',
        link: 'https://www.netflix.com/in/title/80117470'
    },
    {
        id: 3,
        imgsrc: 'https://upload.wikimedia.org/wikipedia/en/thumb/c/c4/House_of_Cards_season_4.png/250px-House_of_Cards_season_4.png',
        title: 'House of Cards',
        channel: 'Netflix Original Series',
        link: 'https://www.netflix.com/in/title/70178217'
    },
    {
        id: 4,
        imgsrc: 'https://www.gstatic.com/tv/thumb/tvbanners/17710222/p17710222_b_v8_aa.jpg',
        title: 'Money Heist',
        channel: 'Netflix Original Series',
        link: 'https://www.netflix.com/in/title/80192098'
    },
    {
        id: 5,
        imgsrc: 'https://www.gstatic.com/tv/thumb/tvbanners/16858361/p16858361_b_v8_ad.jpg',
        title: 'Dark',
        channel: 'Netflix Original Series',
        link: 'https://www.netflix.com/title/80100172'
    },
    {
        id: 6,
        imgsrc: 'https://www.gstatic.com/tv/thumb/tvbanners/17580215/p17580215_b_v8_ac.jpg',
        title: 'the witcher',
        channel: 'Netflix Original Series',
        link: 'https://www.netflix.com/title/80189685'
    },
    {
        id: 7,
        imgsrc: 'https://www.gstatic.com/tv/thumb/tvbanners/15668760/p15668760_b_v8_aa.jpg',
        title: 'Ozark',
        channel: 'Netflix Original Series',
        link: 'https://www.netflix.com/title/80117552'
    },
    {
        id: 8,
        imgsrc: 'https://www.gstatic.com/tv/thumb/tvbanners/16168259/p16168259_b_v8_aa.jpg',
        title: 'The Last Kingdom',
        channel: 'Netflix Original Series',
        link: 'https://www.netflix.com/title/80074249'
    },
];

export default source;